import React from 'react'
import { Home, HistoryEdu, Event, RequestQuote, Desk, Receipt, QueryStats, CancelScheduleSendSharp, Note, AdminPanelSettings, Assignment, Person, Campaign, Quiz } from '@mui/icons-material';

export const SidebarData = [
    {
        title: 'Home',
        icon: <Home />,
        link: '/',
        permissionKey: 'dashboard'
    },
    {
        title: '日報',
        icon: <HistoryEdu />,
        link: '/report',
        permissionKey: 'report_view'
    },
    {
        title: '売上',
        icon: <RequestQuote />,
        link: '/sales',
        permissionKey: 'sales_view',
        submenu: [
            {
                title: '売上一覧',
                link: '/sales',
                permissionKey: 'sales_view'
            },
            {
                title: '見込み客',
                link: '/prospects',
                permissionKey: 'sales_view'
            }
        ]
    },
    {
        title: '予定表',
        icon: <Event />,
        link: '/event',
        permissionKey: 'event_view'
    },
    {
        title: '施設',
        icon: <Desk />,
        link: '/institution',
        permissionKey: 'institution_view'
    },
    {
        title: 'シフト',
        icon: <CancelScheduleSendSharp />,
        link: '/shift',
        permissionKey: 'shift_view',
        submenu: [
            {
                title: 'シフト表',
                link: '/shift',
                permissionKey: 'shift_view'
            },
            {
                title: 'マイシフト',
                link: '/my-shift',
                permissionKey: 'shift_view'
            },
            {
                title: '改シフト表',
                link: '/shift-new',
                permissionKey: 'shift_admin'
            },
            {
                title: 'シフト管理',
                link: '/admin/shift-management',
                permissionKey: 'shift_admin'
            }
        ]
    },
    {
        title: '分析',
        icon: <QueryStats />,
        link: '/analytics',
        permissionKey: 'analytics_view',
        submenu: [
            {
                title: '自己分析',
                link: '/analytics',
                permissionKey: 'analytics_view'
            },
            {
                title: '個人分析',
                link: '/admin/analytics',
                permissionKey: 'analytics_admin'
            },
            {
                title: '目標設定',
                link: '/report-goals',
                permissionKey: 'analytics_view'
            }
        ]
    },
    {
        title: '請求書',
        icon: <Receipt />,
        link: '/invoice',
        permissionKey: 'invoice_view'
    },
    {
        title: 'お知らせ',
        icon: <Campaign />,
        link: '/admin/notices',
        permissionKey: 'notices_view',
        submenu: [
            {
                title: '一覧',
                link: '/notices',
                permissionKey: 'notices_view'
            },
            {
                title: '配信',
                link: '/admin/notices',
                permissionKey: 'notices_admin'
            },
            {
                title: 'プッシュ配信ログ',
                link: '/admin/push-logs',
                permissionKey: 'notices_admin'
            },
            {
                title: 'アクション通知管理',
                link: '/admin/activity-notifications',
                permissionKey: 'notices_admin'
            }
        ]
    },
    {
        title: 'テスト',
        icon: <Quiz />,
        link: '/tests',
        permissionKey: 'tests_view',
        submenu: [
            {
                title: 'テスト一覧',
                link: '/tests',
                permissionKey: 'tests_view'
            },
            {
                title: '回答履歴',
                link: '/tests/history',
                permissionKey: 'tests_view'
            },
            {
                title: '回答履歴管理',
                link: '/admin/tests-history',
                permissionKey: 'tests_admin'
            },
            {
                title: 'テーマ管理',
                link: '/admin/test-themes',
                permissionKey: 'tests_admin'
            }
        ]
    },
    {
        title: '教材',
        icon: <HistoryEdu />,
        link: '/learning',
        permissionKey: 'learning_view',
        submenu: [
            {
                title: '教材ライブラリ',
                link: '/learning',
                permissionKey: 'learning_view'
            },
            {
                title: '教材管理',
                link: '/admin/materials',
                permissionKey: 'learning_admin'
            }
        ]
    },
    {
        title: '勤怠管理',
        icon: <Note />,
        link: '/admin/attendance',
        permissionKey: 'attendance_admin'
    },
    {
        title: '請求書管理',
        icon: <AdminPanelSettings />,
        link: '/admin/invoice',
        permissionKey: 'invoice_admin'
    },
    {
        title: '日報管理',
        icon: <Assignment />,
        link: '/admin/daily-report',
        permissionKey: 'report_admin',
        submenu: [
            {
                title: '日報一覧',
                link: '/admin/daily-report',
                permissionKey: 'report_admin'
            },
            {
                title: 'フィールド設定',
                link: '/admin/report-field-config',
                permissionKey: 'report_admin'
            }
        ]
    },
    {
        title: 'ユーザー管理',
        icon: <Person />,
        link: '/admin/users',
        permissionKey: 'users_admin'
    }
];